<template>
  <div class="main-footer-container text-dark mt-5" :class="darkMode ? 'text-white' : 'text-dark'">
    <!-- <div style="width: 100%">
      <b-row class="m-0 pt-2 justify-content-center" >
        <font-awesome-icon class="mr-3 custom-nav " @click="windowOpen('http://m.me/alexander.paulus.92')"  style="font-size: 20px" :icon="['fab', 'facebook-square']"/>
        <font-awesome-icon class="mr-3 custom-nav " @click="windowOpen('https://wa.me/4915114904081')"  style="font-size: 20px" :icon="['fab', 'whatsapp']"/>
        <a class="text-dark" href="tel:+4915114904081"><font-awesome-icon class="mr-3 custom-nav "  style="font-size: 17px" :icon="['fas', 'phone']"/></a>
        <a class="text-dark" href="mailto:info@ap-webdesign.de"><font-awesome-icon class="mr-3 custom-nav " style="font-size: 17px"  :icon="['fas', 'envelope']"/></a>
      </b-row>
    </div> -->
    <div style="width: 100%">
      <b-row class="m-0 pb-2 justify-content-center ">
          <p class="custom-nav mr-1 pt-1 hover hover-3" @click="$router.push('/datenschutz').catch(err => {})">Datenschutzerklärung</p>
          <p class="pt-1 pr-1">|</p>
          <p class="custom-nav pt-1 hover hover-3" @click="$router.push('/impressum').catch(err => {})">Impressum</p>
      </b-row>
    </div>
    <cookie-banner/>
  </div>
</template>

<script>
import CookieBanner from './CookieBanner'

export default {
  name: 'Footer',
  data() {
    return {
      year: new Date().getFullYear(),
      visible: false
    };
  },
  components: {
     CookieBanner,
  },
  props: {

  },
  computed: {
    darkMode(){
      return this.$store.getters.darkMode
    }
  },
  methods: {
    windowOpen(link){
        window.open(link, "_blank")
    },
    scollToBottom(){
      this.visible = !this.visible
    }
  }
}
</script>

<style scoped>

  .main-footer-container{
    padding-top: auto;
    text-align: center;
    position:relative;
    min-height: 50px;
    width: 100%;
  }

</style>
